export function assetPath(absolutePath: string): string {
  if (absolutePath.charAt(0) !== '/') {
    throw new Error(
      `Paths supplied to this function must be absolute (prefixed with /).`,
    )
  }
  return `${__CHS_INT_WEB_URL_BASE__}${absolutePath}`
}
